module.exports = __webpack_public_path__ + "img/arrow-right-white.e887f1e3.svg";